import React from 'react';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { createMuiTheme } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import CardCreditCard from "./CardCreditCard";
import DispatcherLogform from "./DispatcherLogform";
import GridList from "@material-ui/core/GridList";
import SearchIcon from '@material-ui/icons/Search';
import Divider from '@material-ui/core/Divider';
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import CardCompanyPropertyInformation from "./CardCompanyPropertyInformation";
import CardTowJobInformation from "./CardTowJobInformation";
import CardFullTowJobInformation from "./CardFullTowJobInformation";
import { TimePicker,DatePicker, DateTimePicker, KeyboardDateTimePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";

//import { TimePicker, DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";

//import { TimePicker,DatePicker, DateTimePicker,LocalizationProvider} from "@mui/x-date-pickers";
import FindReplaceIcon from '@material-ui/icons/FindReplace';


import TextVehicleOwner from "./TextVehicleOwner";
import TextTowAgent from "./TextTowAgent";


import {bindActionCreators} from "redux";
import { Document, Page } from 'react-pdf';

import samplePDF from '../../images/79MJ45.pdf';

//import PDF from "react-pdf-js";

//import {ReactPDF} from 'react-pdf';
//import { Document } from 'react-pdf/dist/entry.webpack';

//import { pdfjs } from 'react-pdf';

//import 'react-pdf/dist/Page/AnnotationLayer.css';



import {
    deleteACompanyproperty,
    loadCompanypropertysData,
    saveACompanyproperty, updateACompanyproperty
} from "../../redux/modules/companyproperty";
import {loadCompanysData} from "../../redux/modules/company";
import { loadDispatchsheetsData,
    loadDispatchsheetsDataWithFilter,
    setDispatchPonumberFilter,
    setDispatchStatusFilter,
    setDispatchVinFilter,
    setDispatchPlateFilter,
    setDispatchLocationFilter,
    setDispatchStartTimeFilter,
    setDispatchEndTimeFilter,
    clearDispatchAllFilters ,
    
} from "../../redux/modules/dispatchsheet";
import {connect} from "react-redux";

import PropTypes from "prop-types";
import ExpandableDispatchInformation from "./ExpandableDispatchInformation";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';








import DialogContentText from '@material-ui/core/DialogContentText';
//import {MuiPickersUtilsProvider, TimePicker} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ShowPicturesForDispatch from "./ShowPicturesForDispatch";
//import {KeyboardDateTimePicker} from "@material-ui/pickers";

//import SearchIcon from "@material-ui/core/SvgIcon/SvgIcon";
//import {ReactPDF} from "react-pdf";


//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const useStyles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
});


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 800,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        //backgroundColor:"#e2580d",
        backgroundColor:"#b1e4f2",
        color:"black",
        textTransform: "unset !important",
    },
    gridList: {
        width: '100%',
        height: '100%',
        maxHeight:1400,
    },
    dividerColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#7b32a8",
        backgroundColor:"#7b32a8",
    },
    purplebutton: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#8a4e8a",
        color:"white",
        textTransform: "unset !important",
    },
    root: {
        width: '100%',
        //maxWidth: 4000,
        backgroundColor: theme.palette.background.paper,
    },
    dividerColorPurpole: {
        //marginTop: theme.spacing.unit * 3,
        color:"#760eb3",
        backgroundColor:"#760eb3",
    },
    dividerColor1: {
        //marginTop: theme.spacing.unit * 3,
        color:"#ddedbb",
        backgroundColor:"#ddedbb",
    },
    
});

function PaperComponent(props) {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
          <Paper {...props} />
      </Draggable>
    );
}


class DispatchLogInfo extends React.Component {
    
    state = {
        open: true,
        selectedItem: 'Tows',
        anchorEl: null,
        selectedCompanyInHere : "",
        passingDispatchLog:{},
        editMode:true,
        numPages: null,
        pageNumber: 1,
        vehicleOwnerMode:false,
        towAgentMode:false,
        dispatchlogArray:null,
        showEditScreen:true,
        showPictureMode:false,
        color:"",
        model:"",
        
    };
    
    //const [open, setOpen] = React.useState(false);
    
    constructor(props) {
        super(props);
        this.dispatchlogCardList=null;
        this.statusSelectList=null;
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.getListOfDispatchLogs = this.getListOfDispatchLogs.bind(this);
        //this.handleCompanyChange=this.handleCompanyChange.bind(this);
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.onDocumentComplete = this.onDocumentComplete.bind(this);
        this.vehicleOwnerTextMode = this.vehicleOwnerTextMode.bind(this);
        this.towAgentTextMode = this.towAgentTextMode.bind(this);
        this.loadDispatchLogData = this.loadDispatchLogData.bind(this);
        
        this.handleClickShowEmailSelectClose = this.handleClickShowEmailSelectClose.bind(this);
        this.handleClickShowEmailSelect = this.handleClickShowEmailSelect.bind(this);
        
        this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
        this.handleVinChange = this.handleVinChange.bind(this);
        //this.handleModelChange = this.handleModelChange.bind(this);
        //this.handleMakeChange = this.handleMakeChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handlePonumberChange = this.handlePonumberChange.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        //this.handleDispatchTimeChange = this.handleDispatchTimeChange.bind(this);
        this.getListOfStatusForSelection = this.getListOfStatusForSelection.bind(this);
        this.handleFilterStatusChange = this.handleFilterStatusChange.bind(this);
        this.handleDispatchEndTimeChange = this.handleDispatchEndTimeChange.bind(this);
        this.handleDispatchStartTimeChange = this.handleDispatchStartTimeChange.bind(this);
        this.handleLast24Hours = this.handleLast24Hours.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.refresh = this.refresh.bind(this);
        this.HideOrShowList = this.HideOrShowList.bind(this);
        this.showPicturesMode = this.showPicturesMode.bind(this);
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        //this.PaperComponent = this.PaperComponent.bind(this);
        
        
    }
    
    
    
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    
    editRecord(singleRowData){
        /* let tempPeopleArray=[];
         this.setState({inputFieldShrinkState:true});
         this.setState({selectedProperty:singleRowData });
         this.setState({selectedState: singleRowData.state});
         this.setState({selectedCountry: singleRowData.country});
         if(singleRowData.authorizedpeople != null) {
             tempPeopleArray = JSON.parse(singleRowData.authorizedpeople);
         }

         this.setState({selectedListOfAuthorizedPeople:tempPeopleArray});
         */
        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingDispatchLog :singleRowData });
        this.setState({showEditScreen:true});
        this.setState({showPictureMode: false});
        this.setState({editMode: true});
        /*if(this.state.editMode) {
            this.setState({editMode: false});
        }else{
            this.setState({editMode: true});
        }*/
        //this.setState({vehicleOwnerMode: false});
        //this.setState({editMode: true});
        //this.setState({towAgentMode: false});
        
    }
    
    showPicturesMode(singleRowData){
        
        this.setState({passingDispatchLog :singleRowData });
        this.setState({showEditScreen:true});
        this.setState({showPictureMode: true});
        this.setState({editMode: false});
        
        
    }
    
    
    clearFilters(){
        
        let { clearDispatchAllFilters } = this.props;
        // this.setState({filterStatus:event.target.value});
        clearDispatchAllFilters();
        
        /*this.setState({vin:"", ponumber:"", plate:"",  location:"",  dispatchStartTime:null,  make:"",
            filterStatus:"", dispatchEndTime:null });
        this.setState({vin:""}); */
    }
    
    
    vehicleOwnerTextMode(singleRowData){
        
        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingDispatchLog :singleRowData });
        /*if(this.state.vehicleOwnerMode) {
            this.setState({vehicleOwnerMode: false});
        }else{
            this.setState({vehicleOwnerMode: true});
        }*/
        this.setState({vehicleOwnerMode: true});
        this.setState({editMode: false});
        this.setState({towAgentMode: false});
        
        
    }
    
    towAgentTextMode(singleRowData){
        
        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingDispatchLog :singleRowData });
        /*if(this.state.towAgentMode) {
            this.setState({towAgentMode: false});
        }else{
            this.setState({towAgentMode: true});
        }*/
        this.setState({vehicleOwnerMode: false});
        this.setState({editMode: false});
        this.setState({towAgentMode: true});
        
        
    }
    
    
    
    
    onDocumentComplete(pages) {
        this.setState({ page: 1, pages });
    }
    
    handlePrevious() {
        this.setState({ page: this.state.page - 1 });
    }
    
    handleNext() {
        this.setState({ page: this.state.page + 1 });
    }
    
    renderPagination() {
        return (
          <div>
              <button onClick={this.handlePrevious}>&lt;</button>
              <button onClick={this.handleNext}>&gt;</button>
          </div>
        );
    }
    
    deleteRecord(argProcessId){
        /*
       let { deleteACompanyProperty } = this.props;
       deleteACompanyProperty(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
       */
    }
    
    getListOfStatusForSelection() {
        //let tempArray = this.props.policeArray;
        let returnArray=[];
        returnArray.push(<MenuItem key={'blank'} value={""}>  </MenuItem>);
        returnArray.push(<MenuItem key={'active'} value={"Active"}> Active </MenuItem>);
        returnArray.push(<MenuItem key={'waiting'} value={"Waiting"}>Waiting </MenuItem>);
        returnArray.push(<MenuItem key={'completed'} value={"Complete"}>Complete</MenuItem>);
        
        return(returnArray);
    }
    
    
    getListOfDispatchLogs() {
        let tempArray = this.state.dispatchsheetsArray; //this.props.towjobsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s,index) => {
                s.editMode=false;
                let backgroundColorTemp = '#F7FAFA';
                let tempNumber = index%2;
                if(tempNumber ===0){
                    backgroundColorTemp = '#F6F5ED';
                }
                /* return(

										 <CardTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardTowJobInformation>
									);
				 });*/
                return(
                  <div style={{width:'100%', height:'100%'}}>
                      <ExpandableDispatchInformation dispatch={s} backgroundColor={backgroundColorTemp}  key={s.id} onEdit={this.editRecord} onShowPictures={this.showPicturesMode }  onVehicleOwnerText={this.vehicleOwnerTextMode}  onTowAgentText={this.towAgentTextMode}  onDelete={this.deleteRecord} ></ExpandableDispatchInformation>
                  </div>
            );
            });
            //Duplicating array for testing only.
            //returnArray = returnArray.concat(returnArray);
            
        }
        return(returnArray);
    }
    
    
    componentWillMount(){
        let { loadDispatchsheetsData } = this.props;
        //7_30_2020_ loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere );
        this.applyFilters();
        
        this.setState({
            errorCMsg:{}
        });
        
        
    }
    
    loadDispatchLogData(){
        let { loadDispatchsheetsData } = this.props;
        loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere );
        
        
        this.setState({
            errorCMsg:{}
        });
        
        
    }
    
    componentWillReceiveProps(nextProps) {
        
        let {loadDispatchsheetsData} = this.props;
        
        if (this.props.selectedCompany !== nextProps.selectedCompany) {
            // 7_30_2020_loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany);
            this.applyFilters();
            this.setState({
                selectedCompanyInHere: nextProps.selectedCompany
            });
        }
        /* if (this.props.companysArray !== nextProps.companysArray) {
             this.setState({
                 companysArray: nextProps.companysArray
             });
         }*/
        
        
        this.setState({
            dispatchsheetsArray: nextProps.dispatchsheetsArray
        });
        
        
    }
    
    applyFilters() {
        let { loadDispatchsheetsDataWithFilter } = this.props;
        let filter="";
        if((this.props.dispatchPonumberFilter.length != 0) ||
          (this.props.dispatchVinFilter.length != 0) ||
          (this.props.dispatchLocationFilter.length != 0) ||
          (this.props.dispatchPlateFilter.length != 0) ||
          //(this.state.color.length != 0) ||
          //(this.state.model.length != 0) ||
          (this.props.dispatchStartTimeFilter!= 0)||
          (this.props.dispatchStatusFilter.length!= 0)||
          (this.props.dispatchEndTimeFilter!= 0) ) {
            filter="?";
        }
        
        if((this.props.dispatchVinFilter.length != 0)   ) {
            filter=filter+"vin="+this.props.dispatchVinFilter+"&";
        }
        
        if((this.props.dispatchPonumberFilter.length != 0)   ) {
            filter=filter+"ponumber="+this.props.dispatchPonumberFilter+"&";
        }
        
        if((this.props.dispatchLocationFilter.length != 0)   ) {
            filter=filter+"location="+this.props.dispatchLocationFilter+"&";
        }
        
        if((this.props.dispatchPlateFilter.length != 0)   ) {
            filter=filter+"plate="+this.props.dispatchPlateFilter+"&";
        }
        
        if((this.props.dispatchEndTimeFilter != null)   ) {
            var jsonEndTime = JSON.stringify(this.props.dispatchEndTimeFilter);
            //var jsonEndTime =  this.state.dispatchEndTime;
            filter=filter+"endtime="+jsonEndTime+"&";
        }
        
        if((this.props.dispatchStatusFilter.length != 0)   ) {
            filter=filter+"status="+this.props.dispatchStatusFilter+"&";
        }
        
        if((this.props.dispatchStartTimeFilter != null)   ) {
            var jsonStartTime = JSON.stringify(this.props.dispatchStartTimeFilter);
            //var jsonStartTime =  this.state.dispatchStartTime;
            filter=filter+"starttime="+ jsonStartTime+"&";
            //filter=filter+"starttime="+ this.state.dispatchStartTime+"&";
        }
        
        /*if((this.state.make.length != 0)   ) {
            filter=filter+"vehiclemake="+this.state.make+"&";
        }
        
        if((this.state.vehicleplatenumber.length != 0)   ) {
            filter=filter+"vehicleplatenumber="+this.state.platenumber+"&";
        }*/
        //let filter= "?vehicleyear=2007&";
        loadDispatchsheetsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere,filter  );
        this.handleClickShowEmailSelectClose(false);
        
    }
    
    
    
    handleLast24Hours () {
        let { setDispatchStartTimeFilter,setDispatchEndTimeFilter } = this.props;
        var currentDate = new Date();
        var yesterday= currentDate.getTime()-(24*60*60*1000);
        var yesterdayDate = new Date(yesterday);
        setDispatchEndTimeFilter(currentDate);
        setDispatchStartTimeFilter(yesterdayDate);
        
    }
    
    
    handleFilterStatusChange(event) {
        let { setDispatchStatusFilter } = this.props;
        // this.setState({filterStatus:event.target.value});
        setDispatchStatusFilter(event.target.value);
    };
    
    handleClickShowEmailSelectClose(argKeepDefaultWaiting) {
        
        let { clearDispatchAllFilters, setDispatchStatusFilter } = this.props;
        // this.setState({filterStatus:event.target.value});
        if(argKeepDefaultWaiting ==true) {
            setDispatchStatusFilter("Waiting");
        }else {
        }
        //clearDispatchAllFilters();
        this.setState({showEmailSelectDialog:false});
    };
    
    handleClickShowEmailSelect() {
        
        this.setState({showEmailSelectDialog:true});
        
    };
    handlePlatenumberChange(event) {
        //event.preventDefault();
        let { setDispatchPlateFilter } = this.props;
        
        setDispatchPlateFilter(event.target.value);
        //this.setState({plate:event.target.value});
    }
    handleVinChange(event) {
        //event.preventDefault();
        let { setDispatchVinFilter } = this.props;
        
        setDispatchVinFilter(event.target.value);
        
        //this.setState({vin:event.target.value});
    }
    handleLocationChange(event) {
        //event.preventDefault();
        let { setDispatchLocationFilter } = this.props;
        
        setDispatchLocationFilter(event.target.value);
        
        this.setState({location:event.target.value});
    }
    handlePonumberChange(event) {
        //event.preventDefault();
        let { setDispatchPonumberFilter } = this.props;
        // this.setState({filterStatus:event.target.value});
        setDispatchPonumberFilter(event.target.value);
        //this.setState({ponumber:event.target.value});
    }
    
    /*shouldComponentUpdate = (nextProps, nextState) => {
        if (nextProps.dispatchPonumberFilter != this.props.dispatchPonumberFilter) {
            return true;
        } else {
            return true;
        }
    } */
    /*handleColorChange(event) {
        //event.preventDefault();
        
        this.setState({color:event.target.value});
    }
    handleYearChange(event) {
        //event.preventDefault();
        
        this.setState({year:event.target.value});
    }*/
    
    //<TextField id="vinnumber" name="vinnumber" label="Color" fullWidth InputLabelProps={{ shrink: true }}  value={this.state.color} onChange={this.handleColorChange}   />
    //<TextField id="vinnumber" name="vinnumber" label="Year" fullWidth InputLabelProps={{ shrink: true }}  value={this.state.year} onChange={this.handleYearChange}   />
    
    
    renderFilterCheckBoxes(){
        const {classes} = this.props;
        this.statusSelectList = this.getListOfStatusForSelection();
        
        return(
          <div>
              <Grid container >
                  
                  <Grid item xs={12} sm={12}>
                      <Divider className={classes.dividerColor}></Divider>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      <TextField id="platenumber" name="platenumber" label="Plate Number" fullWidth InputLabelProps={{ shrink: true }}   value={this.props.dispatchPlateFilter} onChange={this.handlePlatenumberChange}   />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      <TextField id="vinnumber" name="vinnumber" label="VIN" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.dispatchVinFilter} onChange={this.handleVinChange}   />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      <TextField id="location" name="location" label="Location" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.dispatchLocationFilter} onChange={this.handleLocationChange}  />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      <TextField id="ponumber" name="ponumber" label="PO Number" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.dispatchPonumberFilter} onChange={this.handlePonumberChange}   />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      <MuiPickersUtilsProvider  utils={DateFnsUtils} >
                          <KeyboardDateTimePicker
                            value={this.props.dispatchStartTimeFilter}
                            onChange={this.handleDispatchStartTimeChange}
                            label="Dispatch Start Time"
                            format="yyyy/MM/dd hh:mm a"
                          />
                          
                          {/*
            <TimePicker
        margin="normal"
        id="time-picker"
        label="Dispatch Start Time"
        value={this.state.dispatchStartTime}
        onChange={this.handleDispatchStartTimeChange}
        KeyboardButtonProps={{
            'aria-label': 'change time',
        }}
    
        /> */}
                      </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      
                      <MuiPickersUtilsProvider  utils={DateFnsUtils} >
                          <KeyboardDateTimePicker
                            value={this.props.dispatchEndTimeFilter}
                            onChange={this.handleDispatchEndTimeChange}
                            label="Dispatch END Time"
                            format="yyyy/MM/dd hh:mm a"
                          />
                          {/*
            <TimePicker
        margin="normal"
        id="time-picker"
        label="Dispatch End Time"
        value={this.state.dispatchEndTime}
        onChange={this.handleDispatchEndTimeChange}
        KeyboardButtonProps={{
            'aria-label': 'change time',
        }}
    
        />  */}
                      </MuiPickersUtilsProvider>
                  </Grid>
                  
                  <Grid item xs={6} sm={6}>
                      <FormControl className={classes.formControl}>
                          <InputLabel htmlFor="age-helper">Status</InputLabel>
                          <Select
                            value={this.props.dispatchStatusFilter}
                            onChange={this.handleFilterStatusChange}
                            inputProps={{
                                name: 'status',
                                id: 'status-helper',
                            }}
                          >
                              
                              {this.statusSelectList}
                          
                          </Select>
                          {/* <FormHelperText>Select a Company </FormHelperText>  */}
                      </FormControl>
                  
                  </Grid>
                  <Grid item xs={6} sm={6}>
                      
                      <Button variant="contained" color="primary" className={classes.button}   onClick={(event) => this.handleLast24Hours(event)} >
                          Last 24 Hours
                      </Button>
                  </Grid>
              </Grid>
          
          </div>
        )
        
        
        
    }
    
    /*handleCompanyChange(argComapnyId){
        let { loadDispatchsheetsData } = this.props;
        //this.setState({selectedCompanyInHere:argComapnyId});
        loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, argComapnyId );
    }*/
    
    handleDispatchStartTimeChange(event) {
        
        let { setDispatchStartTimeFilter } = this.props;
        // this.setState({filterStatus:event.target.value});
        setDispatchStartTimeFilter(event);
        
        //this.setState({dispatchStartTime:event});
    }
    
    
    handleDispatchEndTimeChange(event) {
        let { setDispatchEndTimeFilter } = this.props;
        // this.setState({filterStatus:event.target.value});
        setDispatchEndTimeFilter(event);
        
        //this.setState({dispatchEndTime:event});
    }
    
    refresh(){
        let { loadDispatchsheetsData } = this.props;
        loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany.id );
        
        this.setState({
            errorCMsg:{}
        });
    }
    
    HideOrShowList(){
        if(this.state.showEditScreen == false) {
            this.setState({showEditScreen: true});
        }else{
            this.setState({showEditScreen: false});
        }
    }
    
    
    render() {
        //const classes = useStyles();
        
        const {classes} = this.props;
        //const theme = useTheme;
        const theme = createMuiTheme({
            //direction:'rtl'
        });
        
        let editFrameSize=7;
        let listFrameSize=5;
        
        if(this.state.showEditScreen == false){
            editFrameSize=0;
            listFrameSize=12;
        }else{
            
            editFrameSize=7;
            listFrameSize=5;
        }
        this.dispatchlogCardList = this.getListOfDispatchLogs();
        let filterBoxes =  this.renderFilterCheckBoxes();
        
        //let dragable = this.PaperComponent(this.props);
        
        return (
          <React.Fragment>
              <Grid container spacing={24}>
                  { (this.state.showEditScreen) && (
                    <Grid item xs={editFrameSize} sm={editFrameSize}>
                        {/* < div className = {classes.root} > */}
                        {(this.state.editMode == true)&& (
                          <DispatcherLogform   onEdit={this.editRecord}   onRefreshList={this.loadDispatchLogData}  passedDispatchLog={this.state.passingDispatchLog}
                                               selectedCompany={this.state.selectedCompanyInHere} >  </DispatcherLogform>
                        )}
                        
                        {(this.state.showPictureMode == true)&& (
                          <ShowPicturesForDispatch  onEdit={this.editRecord}  passedDispatchLog={this.state.passingDispatchLog} > </ShowPicturesForDispatch>
                        )}
                        
                        
                        {/*< /div> */}
                    
                    
                    </Grid>
                  )}
                  <Grid item xs={listFrameSize} sm={listFrameSize}   style={{ maxWidth:'100%' }} >
                      
                      <Tooltip title="Filter" aria-label="Filter">
                          <div>
                              <Grid container spacing={24}>
                                  <Grid item xs={3} sm={3}>
                                      { (this.state.showEditScreen == true) && (
                                        
                                        <Button variant="contained" color="primary" style={{fontSize:10, marginBottom:10, marginRight:40}}  onClick={this.HideOrShowList} className={classes.button}  >
                                            Hide Edit
                                        </Button>
                                      
                                      )}
                                      { (this.state.showEditScreen == false) && (
                                        
                                        <Button variant="contained" color="primary" style={{fontSize:10, marginBottom:10, marginRight:40}} onClick={this.HideOrShowList} className={classes.button}  >
                                            Show Edit
                                        </Button>
                                      
                                      )}
                                  </Grid>
                                  <Grid item xs={2} sm={2}>
                                      <IconButton  color="primary" aria-label="edit" className={classes.margin}  onClick={()=>this.handleClickShowEmailSelect()}>
                                          {( (!( (this.props.dispatchPonumberFilter.length != 0) ||
                                            (this.props.dispatchVinFilter.length != 0) ||
                                            (this.props.dispatchLocationFilter.length != 0) ||
                                            (this.props.dispatchPlateFilter.length != 0) ||
                                            //(this.state.color.length != 0) ||
                                            //(this.state.model.length != 0) ||
                                            (this.props.dispatchStartTimeFilter!= null)||
                                            (this.props.dispatchStatusFilter.length!= 0)||
                                            (this.props.dispatchEndTimeFilter!=null) ) )) && (<SearchIcon fontSize="large"  />) }
                                          
                                          
                                          {((((this.props.dispatchPonumberFilter.length != 0) ||
                                            (this.props.dispatchVinFilter.length != 0) ||
                                            (this.props.dispatchLocationFilter.length != 0) ||
                                            (this.props.dispatchPlateFilter.length != 0) ||
                                            //(this.state.color.length != 0) ||
                                            //(this.state.model.length != 0) ||
                                            (this.props.dispatchStartTimeFilter!= null)||
                                            (this.props.dispatchStatusFilter.length!= 0)||
                                            (this.props.dispatchEndTimeFilter!=null) ) )) && (<FindReplaceIcon fontSize="large"  />)}
                                      </IconButton>
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      <Typography variant="h6" color='primary'>
                                          {this.props.dispatchsheetsArray.length} Dispatch Logs
                                      </Typography>
                                  </Grid>
                                  <Grid item xs={2} sm={2}>
                                      <Button variant="contained" color="primary"  style={{fontSize:10, marginBottom:10, }}  onClick={this.refresh} className={classes.button}  >
                                          Refresh List
                                      </Button>
                                  </Grid>
                              </Grid>
                          </div>
                      </Tooltip>
                      <Grid item xs={12} sm={12}  style={{fontSize:10, marginLeft:10}}>
                          <GridList cellHeight={100} className={classes.gridList}>
                              { this.dispatchlogCardList}
                          </GridList>
                      </Grid>
                  </Grid>
                  
                  {/*
            <Dialog
        open={this.state.showEmailSelectDialog}
        onClose={this.handleClickShowEmailSelectClose}
        PaperComponent={PaperComponent}
        scroll={'paper'}
        classes={{
            paper: classes.formControl2,
        }}
        
        aria-labelledby="draggable-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth="xl"
            >
            <DialogTitle id="scroll-dialog-title"  style={{ cursor: 'move' }}>Filter  Selection</DialogTitle>
        <DialogContent  id="farshids"   dividers="paper">
        
            <div>
            Please select the filters
        </div>
        {filterBoxes}
    </DialogContent>
        <DialogActions>
        <Tooltip title="Filters for the columns">
            <Button  color="primary" onClick={this.applyFilters}>Apply Filters</Button>
        </Tooltip>
    
        <Button onClick={this.handleClickShowEmailSelectClose} color="secondary">Close</Button>
            </DialogActions>
            </Dialog>
            */}
                  
                  
                  <Dialog
                    open={this.state.showEmailSelectDialog}
                    onClose={()=>this.handleClickShowEmailSelectClose(true)}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                  >
                      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                          Dispatch Filters
                      </DialogTitle>
                      <DialogContent>
                          {/*<DialogContentText>
        Please select the filters
        </DialogContentText>*/}
                          {filterBoxes}
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.applyFilters} color="primary">
                              Apply Filters
                          </Button>
                          <Button onClick={this.clearFilters} color="secondary">
                              Clear filters
                          </Button>
                          <Button autoFocus onClick={()=>this.handleClickShowEmailSelectClose(true)} color="secondary">
                              Cancel
                          </Button>
                      </DialogActions>
                  </Dialog>
              
              
              </Grid>
          </React.Fragment>
        );
    }
    
}

DispatchLogInfo.propTypes = {
    classes: PropTypes.object.isRequired,
};



const mapStateToProps = (state) => {
    return {
        dispatchsheetsArray: state.dispatchsheet.dispatchsheetsArray,
        selectedCompany:state.company.selectedCompany,
        //selectedCompany:state.company.selectedCompany,
        dispatchStatusFilter:state.dispatchsheet.dispatchStatusFilter,
        dispatchPonumberFilter:state.dispatchsheet.dispatchPonumberFilter,
        dispatchVinFilter:state.dispatchsheet.dispatchVinFilter,
        dispatchPlateFilter:state.dispatchsheet.dispatchPlateFilter,
        dispatchLocationFilter:state.dispatchsheet.dispatchLocationFilter,
        dispatchStartTimeFilter:state.dispatchsheet.dispatchStartTimeFilter,
        dispatchEndTimeFilter:state.dispatchsheet.dispatchEndTimeFilter,
        /*CompanyPropertyDeleteResponse:state.companyproperty.deleteCompanypropertyResp,
        CompanyPropertySaveResponse:state.companyproperty.saveCompanypropertyResp,
        companysArray: state.company.companysArray,
        */
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.companyproperty.errorCMsg,
    };
};


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadDispatchsheetsData:loadDispatchsheetsData,
        loadDispatchsheetsDataWithFilter:loadDispatchsheetsDataWithFilter,
        setDispatchStatusFilter:setDispatchStatusFilter,
        setDispatchPonumberFilter:setDispatchPonumberFilter,
        setDispatchVinFilter:setDispatchVinFilter,
        setDispatchPlateFilter:setDispatchPlateFilter,
        setDispatchLocationFilter:setDispatchLocationFilter,
        setDispatchStartTimeFilter:setDispatchStartTimeFilter,
        setDispatchEndTimeFilter:setDispatchEndTimeFilter,
        clearDispatchAllFilters:clearDispatchAllFilters,
        /*deleteACompanyproperty:deleteACompanyproperty,
        saveACompanyproperty:saveACompanyproperty,
        updateACompanyproperty:updateACompanyproperty,
        loadCompanysData:loadCompanysData,*/
        
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DispatchLogInfo));
